import { signal, batch } from '@preact/signals-react'

export const isReportsHandlerLoading = signal(false)
export const reportsHandlerTableData = signal([])
export const isOpenReportsTransferModal = signal([])

export const reportsHandlerClearSignals = () => batch(() => {
	isReportsHandlerLoading.value = false
	reportsHandlerTableData.value = []
	isOpenReportsTransferModal.value = []
})